import OrderProductNameDefineMethodStrategy from "@/domain/OrderProductNameDefineMethodStrategy";

export const DefineByExecutor = new OrderProductNameDefineMethodStrategy(0,"Определяется поставщиком")
export const DefinedInOrder = new OrderProductNameDefineMethodStrategy(1, "Установлен в заказе")